import { render, staticRenderFns } from "./OrderDeliverUpdate.vue?vue&type=template&id=53a15f1e&scoped=true&"
import script from "./OrderDeliverUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderDeliverUpdate.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeliverUpdate.vue?vue&type=style&index=0&id=53a15f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a15f1e",
  null
  
)

export default component.exports